import { render, staticRenderFns } from "./WizardHolderCustomer.vue?vue&type=template&id=4d48789a&scoped=true&"
import script from "./WizardHolderCustomer.vue?vue&type=script&lang=js&"
export * from "./WizardHolderCustomer.vue?vue&type=script&lang=js&"
import style0 from "./WizardHolderCustomer.vue?vue&type=style&index=0&id=4d48789a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48789a",
  null
  
)

export default component.exports